import { render, staticRenderFns } from "./balanceInfo.vue?vue&type=template&id=08ab0197&scoped=true"
import script from "./balanceInfo.vue?vue&type=script&lang=js"
export * from "./balanceInfo.vue?vue&type=script&lang=js"
import style0 from "./balanceInfo.vue?vue&type=style&index=0&id=08ab0197&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08ab0197",
  null
  
)

export default component.exports